var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-content"},[_c('div',{staticClass:"empty-content__icon"},[_c('svg-icon',{attrs:{"type":_vm.content.icon}})],1),_c('div',{staticClass:"empty-content__title"},[_vm._v(_vm._s(_vm.content.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }